import copilotSettingsStore from '../store/store';

export function getTenantDefaultAddin(mailboxInfo: any): string | undefined {
    const store = copilotSettingsStore(mailboxInfo);
    return store.extensibility.settingsFromService?.metaOSApps?.tenantDefault;
}
